<template>
    <div class="privacy-policy-ctn">
        <div class="markdown-typed-wrap typo">
            <p>他趣秒中隐私政策</p>
            <p>一、概述</p>
            <p>他趣秒中是一款由杭州市西湖区十分钟信息技术工作室开发的时钟浮窗软件，提供用户在电脑或手机设备上显示实时时间的浮窗功能。本软件需要网络能力以实现时间同步和在线注册功能。为了保护用户的隐私，我们制定了以下隐私政策。</p>
            <p>二、收集的个人信息</p>
            <ol>
                <li>用户注册信息：在用户注册时，我们会收集用户的基本信息，包括但不限于用户名、密码、邮箱等。</li>
                <li>设备信息：为了确保软件的正常运行，我们会收集用户的设备信息，包括操作系统版本、设备型号、屏幕分辨率等。</li>
                <li>网络信息：为了实现时间同步和在线注册功能，我们会收集用户的网络信息，包括IP地址、网络类型等。</li>
            </ol>
            <p>三、个人信息的使用和共享</p>
            <ol>
                <li>用户注册信息：我们会将用户注册信息用于创建用户账户、发送注册确认邮件以及为用户提供个性化服务。</li>
                <li>设备信息：我们会将设备信息用于优化软件的性能和用户体验。</li>
                <li>网络信息：我们会将网络信息用于实现时间同步和在线注册功能。</li>
            </ol>
            <p>四、隐私保护措施</p>
            <ol>
                <li>加密技术：我们将对用户的个人信息进行加密存储，以增强数据安全性。</li>
                <li>访问控制：我们将严格控制对用户个人信息的访问权限，只有经过授权的员工才能访问。</li>
                <li>数据安全：我们将采取必要的安全措施，以防止用户个人信息的泄露、篡改或损坏。</li>
            </ol>
            <p>五、第三方链接</p>
            <p>本软件可能含有第三方链接或广告。对于这些链接或广告中的内容，我们不承担任何责任。这些链接或广告可能会收集用户的个人信息，建议您在使用这些链接或广告时谨慎处理自己的个人信息。</p>
            <p>六、政策更新与透明度</p>
            <p>本隐私政策可能会根据我们的业务需求和技术发展进行更新。我们将在更新后的隐私政策中明确更新日期。同时，我们将在更新后的隐私政策中保持对用户的透明度，及时通知用户关于个人信息的收集、使用和共享方面的变化。</p>
            <p>七、联系方式与投诉渠道</p>
            <p>如果您对我们在收集、使用或共享您的个人信息方面有任何疑问或投诉，请通过以下方式与我们联系：
                电子邮件：<a href="mailto:ice.king@gmail.com">ice.king@gmail.com</a></p>
        </div>
    </div>
</template>
<style lang="less">
.privacy-policy-ctn{
    text-align: left;
}
</style>
<script>
export default {
    name: "PrivacyPolicy"
}
</script>
